import React, {Component} from 'react';
import { connect} from 'react-redux'
import {bindActionCreators, compose} from 'redux'
import CTable from '@/components/CTable'
import CButton from '@/components/CButton'
import CBaseComponent from '@/components/CBaseComponent'
import { setReload } from "@/redux/common/action";
import { tableData, tableData1, tableData2, tableData3} from './data'
import './index.scss'
import { getPftjHandler } from "@/servers/goodsManageApi";
import {withRouter} from "react-router-dom";
import { Radio } from 'antd';


@CBaseComponent
class GoodsManageList extends Component{
  constructor(props) {
    super(props);
    this.getListData = this.getListData.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    // this.getListData();
  }


  state = {
    columns: tableData.tHead,
    columns1: tableData1.tHead,
    columns2: tableData2.tHead,
    columns3: tableData3.tHead,
    dataSource: tableData.tBody,
    dataSource1: tableData1.tBody,
    dataSource2: tableData2.tBody,
    dataSource3: tableData3.tBody,
    loading: true,
  };

  // 获取用户列表数据
  getListData(){
    this.setState({
      loading: true
    });
    getPftjHandler().then(res=>{
      let data =JSON.parse(JSON.stringify(res.records[0].datalist))
      let total = 1;
      this.setState({
        dataSource: data,
        page: {...this.state.page, total},
        loading: false
      });
    }).catch(err=>{
      console.log(err,'rttt')
    })
  }

  componentWillMount(){

  }

  componentDidMount(){
    this.getListData();
  }
  render(){
    return (
        <div className='user-manage-list'>
          <CTable ref='userManageList' checked={false} loading={this.state.loading} columns={this.state.columns} dataSource={this.state.dataSource} onTableChange={this.onTableChange}>
            <div
                slot='operate1'
                render={(text, record, index) => (
                    <div className='operate'>
                      <Radio.Group onChange={(e) => this.onChange(e,record)} value={this.computeds(record)}>
                        <Radio value='允许'>允许</Radio>
                        <Radio value='不允许'>不允许</Radio>
                      </Radio.Group>
                    </div>
                )} />
            <div
                slot='operate'
                render={(text, record, index) => (
                    <div className='operate'>
                      <CButton type='text' authId='goodsManageListEdit' onClick={() => this.editHandler(record)}>重置</CButton>
                    </div>
                )} />
          </CTable>
          <CTable ref='userManageList1' checked={false} loading={this.state.loading} columns={this.state.columns1} dataSource={this.state.dataSource1} onTableChange={this.onTableChange}>
            <div
                slot='operate1'
                render={(text, record, index) => (
                    <div className='operate'>

                      <Radio.Group onChange={(e) => this.onChange(e,record)} value={this.computeds(record)}>
                        <Radio value='允许'>允许</Radio>
                        <Radio value='不允许'>不允许</Radio>
                      </Radio.Group>
                    </div>
                )} />
            <div
                slot='operate'
                render={(text, record, index) => (
                    <div className='operate'>
                      <CButton type='text' authId='goodsManageListEdit' onClick={() => this.editHandler(record)}>重置</CButton>
                    </div>
                )} />
          </CTable>
          <CTable ref='userManageList2' checked={false} loading={this.state.loading} columns={this.state.columns2} dataSource={this.state.dataSource2} onTableChange={this.onTableChange}>
            <div
                slot='operate1'
                render={(text, record, index) => (
                    <div className='operate'>

                      <Radio.Group onChange={(e) => this.onChange(e,record)} value={this.computeds(record)}>
                        <Radio value='允许'>允许</Radio>
                        <Radio value='不允许'>不允许</Radio>
                      </Radio.Group>
                    </div>
                )} />
            <div
                slot='operate'
                render={(text, record, index) => (
                    <div className='operate'>
                      <CButton type='text' authId='goodsManageListEdit' onClick={() => this.editHandler(record)}>重置</CButton>
                    </div>
                )} />
          </CTable>
          <CTable ref='userManageList3' checked={false} loading={this.state.loading} columns={this.state.columns3} dataSource={this.state.dataSource3} onTableChange={this.onTableChange}>
            <div
                slot='operate1'
                render={(text, record, index) => (
                    <div className='operate'>

                      <Radio.Group onChange={(e) => this.onChange(e,record)} value={this.computeds(record)}>
                        <Radio value='允许'>允许</Radio>
                        <Radio value='不允许'>不允许</Radio>
                      </Radio.Group>
                    </div>
                )} />
            <div
                slot='operate'
                render={(text, record, index) => (
                    <div className='operate'>
                      <CButton type='text' authId='goodsManageListEdit' onClick={() => this.editHandler(record)}>重置</CButton>
                    </div>
                )} />
          </CTable>
        </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    reload: state.reload,
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    setReload: bindActionCreators(setReload, dispatch)
  }
};

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(GoodsManageList);
